import React from 'react';
import { Grid, Link } from '@mui/material';

export default function PrivacyPolicyTab() {
  return (
    <Grid container padding={2} sx={styles.main}>
      <Grid item>
        <Link
          href={'https://www.procurefix.com/privacy-policy'}
          target='_blank'
          rel='noopener noreferrer'
        >
          Privacy Policy
        </Link>
      </Grid>
    </Grid>
  );
}

const styles = {
  main: {
    justifyContent: 'center',
  },
};
